import styled from "styled-components";
import LoadingAnimation from "../../../components/loadingAnimation";

const WidgetsLoadingUi = () => {
  return (
    <Wrapper>
      <div className="loading-animation-card">
        <LoadingAnimation />
        <span>Loading...</span>
      </div>
    </Wrapper>
  );
};

export default WidgetsLoadingUi;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.background};
  height: 100%;
  width: 100%;
  .loading-animation-card {
    transform: translate(calc(50vw - 50%), 50%);
    width: 576px;
    height: 324px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border-radius: 20px;
    background-color: ${({ theme }) => theme.widget.background};
    span {
      font-size: 14px;
      color: #91a1ac;
      font-weight: 500;
    }
  }
`;
